// TODO: use the reselect library for these selectors, since it provides handy features like selector hoisting.
// returns device from device array and deviceid
export const deviceSelector = (devices, deviceid) => {
  let potentialDevice = devices.filter(device => {
    return device.uid === deviceid;
  });
  return potentialDevice[0] || undefined;
};

// returns resolvedSensorConfig for device and sensorid
export const resolvedSensorConfigSelector = (device, sensorid) => {
  let rv = undefined;
  if (
    device &&
    device.resolvedSensorConfig &&
    device.resolvedSensorConfig[sensorid]
  ) {
    let res = {};

    // Take the local values (sensorConfig) if the method is "manual", else take the resolved values from device api.
    let object = device.sensorConfig[sensorid];
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        const element = object[key];
        if (element.hasOwnProperty("method") && element.method === "JSON") {
          res[key] = device.resolvedSensorConfig[sensorid][key];
        } else {
          res[key] = element;
        }
      }
    }
    rv = res;
  }

  return rv;
};

// returns resolvedDataConfig for device.
export const resolvedDataConfigSelector = device => {
  let rv = undefined;
  if (device && device.resolvedDataConfig) {
    rv = device.resolvedDataConfig;
  }

  return rv;
};

export const liveSensorValuesSelector = (device, sensorid) => {
  let rv = undefined;
  if (device) {
    let { liveSensorValues = {} } = device;
    let sensorvalue = liveSensorValues[sensorid];
    rv = sensorvalue;
  }
  return rv;
};
